<template>
  <div>
    <!-- HEADER
      ================================================== -->
    <section class="section section_header section_header__menu">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <!-- Heading -->
            <h1 class="section__heading section_header__heading text-center">
              Speisekarte
            </h1>
          </div>
        </div>
        <!-- .row -->
      </div>
      <!-- .container -->
      <div class="section_header__bg menu_bg"></div>
    </section>
    <!-- section menu -->
    <section class="section_menu" id="section_menu">
      <div class="container">
        <!--
        <div class="row">
          <div class="col-sm-12">
            <h2 class="section_title">&#8722; Menü &#8722;</h2>
            <hr class="section_title_line" />
            <p class="section_caption">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Impedit
              mollitia, temporibus aliquid quae, repellendus eaque? Illo harum
              omnis sed debitis ratione dolor.
            </p>
          </div>
        </div>
        -->
        <!-- Filter
        <div class="row">
          <div class="col-sm-12">
            <ul class="nav nav-tabs menu_nav">
              <li role="presentation" class="active">
                <a href="#" role="tab" data-filter=".menu-text_breakfast"
                  >Breakfast</a
                >
              </li>
              <li role="presentation">
                <a href="#" role="tab" data-filter=".menu-text_lunch">Lunch</a>
              </li>
              <li role="presentation">
                <a href="#" role="tab" data-filter=".menu-text_dinner"
                  >Dinner</a
                >
              </li>
              <li role="presentation">
                <a href="#" role="tab" data-filter=".menu-text_drinks"
                  >Drinks</a
                >
              </li>
              <li role="presentation">
                <a href="#" role="tab" data-filter=".menu-text_desserts"
                  >Desserts</a
                >
              </li>
            </ul>
          </div>
        </div>

        /Filter -->

        <div
          class="row menu__category"
          v-for="(dishCategory, index) in dishes"
          :key="index"
        >
          <span class="section_title">{{ dishCategory.title }}</span>
          <div class="row menu__text-grid">
            <div
              class="col-sm-6 menu__item"
              v-for="(entry, index) in dishCategory.entries"
              :key="index"
            >
              <h3>
                {{ entry.no }} {{ entry.title }}
                <span class="price">{{ entry.price.toFixed(2) }} €</span>
              </h3>
              <!--
              <p class="dish_ingredients">
                eggs / bacon / oil / beans / tomato
              </p>
              -->
              <p class="dish_info" v-if="entry.description">
                {{ entry.description }}
              </p>
              <p class="dish_info" v-else>
                <span class="empty">-/-</span>
              </p>
            </div>
          </div>
          <!-- .row -->
        </div>
      </div>
      <!-- .container -->
    </section>
  </div>
</template>

<script>
import MenuData from "@/data/menu";
export default {
  name: "Speisekarte",
  metaInfo: {
    title: "Speisekarte - Restaurant Dafni Aurich"
  },
  data() {
    return {
      dishes: MenuData.dishes,
      drinks: MenuData.drinks
    };
  }
};
</script>

<style lang="scss">
.row .menu__text-grid {
  margin: 0;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

.section_menu .menu__text-grid .menu__item {
  padding: 10px 10px;
}

.section_menu .menu__text-grid .menu__item > h3 {
  position: relative;
  padding-right: 70px;

  & .price {
    position: absolute;
    right: 8px;
    bottom: 5px;
  }
}

@media (max-width: 991px) {
  .section_menu .menu__text-grid .menu__item .dish_info {
    padding-left: 8px;
    padding-right: 8px;
  }
}

@media screen and (max-width: 375px) {
  .menu__category .section_title {
    padding: 0 40px;
  }
}

.section_menu .menu__category .section_title {
  display: block;
  text-align: center;
  font-size: 27px;
  &:before {
    content: "";
  }
}

.dish_info .empty {
  visibility: hidden;
}

.menu__category .menu__item:nth-child(odd) {
  clear: both;
}

@media screen and (max-width: 767px) {
  .section_menu .menu__category .section_title {
    font-size: 25px;
  }
}
</style>
